import Utils from 'app/utils/utils';

export {};
declare global {
    interface String {
        capitalizeFirstLetter(): string;

        cleanSpaces(): string;

        isEmpty(): boolean;
    }
}

String.prototype.capitalizeFirstLetter = function() {
    return this.charAt(0).toUpperCase() + this.slice(1).toLocaleLowerCase();
};

String.prototype.cleanSpaces = function() {
    return Utils.cleanSpaces(this);
};

String.prototype.isEmpty = function() {
    return this.trim().length === 0;
};
